
const beginsWithHTTP = /^https?:\/\//i;

function addMissingHTTP(url) {
  const urlString = String(url).trim();
  if (urlString.length === 0 || urlString[0] === '/' || beginsWithHTTP.test(urlString)) {
    return urlString;
  }
  return `http://${urlString}`;
}

function splitFirstParagraph(htmlString) {
  const regexBr = /<br\s*\/?>\s*<br\s*\/?>/i;
  const regexP = /<\/p>/i;
  let matchBr = regexBr.exec(htmlString);
  let matchP = regexP.exec(htmlString);
  if (matchBr && matchP) {
    if (matchBr.index < matchP.index) {
      matchP = null;
    } else {
      matchBr = null;
    }
  }
  if (matchBr) {
    const opis = htmlString.slice(0, matchBr.index);
    const opis2 = `<p>${htmlString.slice(matchBr.index + matchBr[0].length)}`;
    if (opis2.length > 100) {
      return [opis, opis2];
    }
  } else if (matchP) {
    const opis = htmlString.slice(0, matchP.index + matchP[0].length);
    const opis2 = `${htmlString.slice(matchP.index)}`;
    if (opis2.length > 100) {
      return [opis, opis2];
    }
  }
  return [htmlString];
}

export {
  addMissingHTTP,
  splitFirstParagraph,
};



// WEBPACK FOOTER //
// ./src/utils.js